module.exports = __webpack_public_path__ + "static/media/aws-logo.4791604a.svg";